import { Spinner as ChakraSpinner, type SpinnerProps } from '@chakra-ui/react';
import React from 'react';

const Spinner = (props: SpinnerProps) => (
  <ChakraSpinner css={{ '_spinner-track-color': 'gray.50' }} animationDuration="0.75s" {...props} />
);

export default Spinner;
